import React from "react";

export const ProductivityReportLayer = () => {
  // STATIC PRODUCTIVITY DATA
  const data = [
    {
      id: 1,
      user_name: "Rahul Sharma",
      team_name: "Sales Team A",
      total_calls: 120,
      total_talk_time: "5h 30m",
      avg_call_duration: "2m 45s",
      productive_calls: 85,
      idle_time: "45m",
      productivity_score: 88,
    },
    {
      id: 2,
      user_name: "Amit Verma",
      team_name: "Sales Team B",
      total_calls: 95,
      total_talk_time: "4h 05m",
      avg_call_duration: "2m 30s",
      productive_calls: 62,
      idle_time: "1h 10m",
      productivity_score: 71,
    },
  ];

  const getBadge = (score) => {
    if (score >= 80) return "bg-success";
    if (score >= 60) return "bg-warning";
    return "bg-danger";
  };

  return (
    <div className="card border-0 shadow-sm" style={{ borderRadius: "16px", overflow: "hidden" }}>
      {/* HEADER */}
      <div className="card-header bg-light border-bottom border-light-subtle px-4 py-3">
        <h5 className="mb-0 fw-bold text-dark" style={{ fontSize: "16px" }}>Productivity Analysis Report</h5>
      </div>

      <div className="card-body p-4">
        {/* FILTERS (STATIC UI) */}
        <div className="row mb-4 g-3">
          <div className="col-md-3">
            <label className="form-label text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Team</label>
            <select className="form-select border-0 bg-light" style={{ borderRadius: "10px", fontSize: "14px", padding: "10px" }}>
              <option>All Teams</option>
              <option>Sales Team A</option>
              <option>Sales Team B</option>
            </select>
          </div>

          <div className="col-md-3">
            <label className="form-label text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>User</label>
            <select className="form-select border-0 bg-light" style={{ borderRadius: "10px", fontSize: "14px", padding: "10px" }}>
              <option>All Users</option>
              <option>Rahul Sharma</option>
              <option>Amit Verma</option>
            </select>
          </div>

          <div className="col-md-3">
            <label className="form-label text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>From Date</label>
            <input type="date" className="form-control border-0 bg-light" style={{ borderRadius: "10px", fontSize: "14px", padding: "10px" }} />
          </div>

          <div className="col-md-3">
            <label className="form-label text-muted small fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>To Date</label>
            <input type="date" className="form-control border-0 bg-light" style={{ borderRadius: "10px", fontSize: "14px", padding: "10px" }} />
          </div>
        </div>

        {/* TABLE */}
        <div className="table-responsive" style={{ border: "1px solid #E2E8F0", borderRadius: "12px" }}>
          <table className="table table-hover align-middle mb-0" style={{ fontSize: "14px" }}>
            <thead className="table-light">
              <tr>
                <th className="ps-4 py-3 text-muted fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>#</th>
                <th className="py-3 text-muted fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>User</th>
                <th className="py-3 text-muted fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Team</th>
                <th className="py-3 text-muted fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Total Calls</th>
                <th className="py-3 text-muted fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Total Talk Time</th>
                <th className="py-3 text-muted fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Avg Call Duration</th>
                <th className="py-3 text-muted fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Productive Calls</th>
                <th className="py-3 text-muted fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Idle Time</th>
                <th className="pe-4 py-3 text-muted fw-bold text-uppercase" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>Productivity</th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan="9" className="text-center text-muted py-4">
                    No data found
                  </td>
                </tr>
              ) : (
                data.map((item, index) => (
                  <tr key={item.id} style={{ transition: "all 0.15s ease" }}>
                    <td className="ps-4 text-muted small">{index + 1}</td>
                    <td className="py-3">
                      <div className="d-flex align-items-center gap-3">
                        <div 
                          className="d-flex align-items-center justify-content-center text-white fw-bold rounded-circle"
                          style={{ 
                            width: "32px", 
                            height: "32px", 
                            background: "linear-gradient(135deg, #6366F1, #4F46E5)",
                            fontSize: "12px",
                            flexShrink: 0
                          }}
                        >
                          {item.user_name ? item.user_name.charAt(0).toUpperCase() : "U"}
                        </div>
                        <span className="fw-bold text-dark">{item.user_name}</span>
                      </div>
                    </td>
                    <td className="py-3 text-secondary">{item.team_name}</td>
                    <td className="py-3 fw-semibold">{item.total_calls}</td>
                    <td className="py-3 text-muted">{item.total_talk_time}</td>
                    <td className="py-3 text-muted">{item.avg_call_duration}</td>
                    <td className="py-3 text-success fw-medium">{item.productive_calls}</td>
                    <td className="py-3 text-danger">{item.idle_time}</td>
                    <td className="pe-4 py-3">
                      <div className="d-flex align-items-center gap-2" style={{ minWidth: "120px" }}>
                        <div className="progress flex-grow-1" style={{ height: "6px", borderRadius: "3px", background: "#E2E8F0" }}>
                          <div 
                            className="progress-bar" 
                            style={{ 
                              width: `${item.productivity_score}%`, 
                              backgroundColor: item.productivity_score >= 80 ? "#10B981" : item.productivity_score >= 60 ? "#F59E0B" : "#EF4444", 
                              borderRadius: "3px",
                              transition: "width 0.5s ease"
                            }}
                          />
                        </div>
                        <span className="fw-bold text-dark small">{item.productivity_score}%</span>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ProductivityReportLayer;
